import './instrument';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import SubscriptionPage from './components/pages/subscription';
import StatusPage from './components/pages/statusPage';
import LoginPage from './components/pages/loginPage';
import { AuthProvider } from './contexts/authContext';
import { CartProvider } from './contexts/cartContext';
import { ThemeProvider } from '@/components/commons/themeProvider';
import '@/utils/i18n';
import { stripePriceIds, stripeEnv } from '@/utils/config';
import './global.css';

const router = createBrowserRouter([
  {
    // Compatibility with old URLs
    path: '/subscription.html',
    element: <SubscriptionPage />,
  },
  {
    path: '/subscribe',
    element: <SubscriptionPage />,
  },
  {
    path: '/status',
    element: <StatusPage />,
  },
  // Dev-only login page
  ...(import.meta.env.MODE === 'development' ? [{ path: '/login', element: <LoginPage /> }] : []),
  // other routes are redirected to subscription page
  {
    path: '*',
    element: <Navigate to={`/subscription.html?priceid=${stripePriceIds[stripeEnv].yearly}`} replace />,
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <ThemeProvider>
    <AuthProvider>
      <CartProvider>
        <RouterProvider router={router} />
      </CartProvider>
    </AuthProvider>
  </ThemeProvider>
  // </React.StrictMode>
);
